module.exports = __webpack_public_path__ + "static/media/UserProfile.a317fb6b.png";